/**
 * Ring — хувь харуулах цагираг (64px, зузаан 6). Дашбоардын KPI.
 *
 * `Meter`-ийн дугуй хувилбар: өнгө нь ТӨЛӨВ заана (`accent` хэвийн,
 * `alert` анхаарал), ангилал биш. Ачаалагдахдаа 0-ээс зурагдана.
 */

import { formatQty } from '@boots/domain';
import { useTween } from '../lib/use-tween';

const SIZE = 64;
const STROKE = 6;
const R = SIZE / 2 - STROKE / 2 - 2;
const C = 2 * Math.PI * R;

export function Ring({ value, tone = 'accent', label }: {
  /** 0–100. Хязгаараас гарсан утгыг өөрөө таслана. */
  value: number;
  tone?: 'accent' | 'alert';
  label: string;
}) {
  const pct = Math.min(100, Math.max(0, Number.isFinite(value) ? value : 0));
  const p = useTween(pct);

  return (
    <span role="img" aria-label={`${label} ${Math.round(pct)}%`} className="relative grid size-16 shrink-0 place-items-center">
      <svg viewBox={`0 0 ${SIZE} ${SIZE}`} className="absolute inset-0 size-full -rotate-90" aria-hidden>
        <circle cx={SIZE / 2} cy={SIZE / 2} r={R} fill="none" stroke="var(--color-track)" strokeWidth={STROKE} />
        <circle
          cx={SIZE / 2} cy={SIZE / 2} r={R} fill="none"
          stroke={tone === 'alert' ? 'var(--color-alert)' : 'var(--color-accent)'}
          strokeWidth={STROKE} strokeLinecap="round"
          strokeDasharray={C} strokeDashoffset={C * (1 - p / 100)}
        />
      </svg>
      <span aria-hidden className="num relative text-meta font-bold">{formatQty(p)}%</span>
    </span>
  );
}
